import { taskFileGroupTypeTypeDef } from "./task-file-group-type-type-def";
import { taskFileTypeDef } from "../../taks-file/definitions/task-file-type-def";
import { taskFileGroupMessageTypeDef } from "./task-file-group-message-type-def";

export const taskFileGroupTypeDef = `
  id
  taskId
  taskFileGroupTypeId
  taskFileGroupType {
    ${taskFileGroupTypeTypeDef}
  }
  source
  taskFiles {
    ${taskFileTypeDef}
  }
  state
  messages {
    ${taskFileGroupMessageTypeDef}
  }
  downloadAllFilesUrl
`;
